import { registerModuleDataProvider } from '../../../providers/CustomDataProvider';
import { Resources } from '../../resource';
import { redpacketWithdrawalsDataProvider } from './dataProvider';

export function initSocialTradingRedpacketWithdrawalsDataProvider() {
  registerModuleDataProvider(
    Resources.socialTradingRedpacketWithdrawals,
    redpacketWithdrawalsDataProvider
  );
}

initSocialTradingRedpacketWithdrawalsDataProvider();
